import { render, staticRenderFns } from "./CommonReadRrResult.vue?vue&type=template&id=3b67efa5&scoped=true"
import script from "./CommonReadRrResult.vue?vue&type=script&lang=js"
export * from "./CommonReadRrResult.vue?vue&type=script&lang=js"
import style0 from "./CommonReadRrResult.vue?vue&type=style&index=0&id=3b67efa5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b67efa5",
  null
  
)

export default component.exports